export enum DCJStep {
    Mapping = 'mapping',
    Encryption = 'encryption',
    Harvester = 'harverster',
    Cleaning = 'cleaning',
    Anonymiser = 'anonymiser',
    Loader = 'loader',
}

export const stepNameMapping: any = {
    harvester: 'collection',
    mapping: 'mapping',
    cleaning: 'cleaning',
    anonymiser: 'confidentiality',
    encryption: 'encryption',
    loader: 'loader',
};

export const SAMPLE_LIMIT = 1000 * 500; // 500KB
